import axios from 'axios';
import { GET_SUBSCRIPTION_STATUS } from './constants';

export function getSubscriptionStatus(data, params?) {
  return axios
    .post(GET_SUBSCRIPTION_STATUS, data, { params, withCredentials: true })
    .catch((error) => {
      return Promise.reject(new Error(error.message));
    });
}
